const MIN_HEIGHR = 400;
const MAX_HEIGHT = 900;
export const store = {
  state: {
    tableHeight: 450,
    showMore: false
  },
  UPDATE_TABLE_HEIGHT () {
    this.state.tableHeight = computedTableHeight();
  },
  TOGGLE_SHOW_MORE (showMore) {
    this.state.showMore = showMore;
    if (!showMore) {
      setTimeout(() => {
        this.state.tableHeight = computedTableHeight();
      }, 350);
    }
  }
};

function computedTableHeight () {
  let documentHeight = document.documentElement.clientHeight;

  let appHeader = document.querySelector('.app-header');
  let appFooter = document.querySelector('.app-footer');
  let rtHeader = document.querySelector('.rt-header');
  let pagination = document.querySelector('.rt-table-pagination');
  let tableHeader = document.querySelector('.rt-table-header');
  let tab = document.querySelector('.rt-tab');

  let appHeaderHeight = appHeader ? appHeader.clientHeight : 0;
  let appFooterHeight = appFooter ? appFooter.clientHeight : 0;
  let rtHeaderHeight = rtHeader ? rtHeader.clientHeight : 0;
  let paginationHeight = pagination ? pagination.clientHeight : 0;
  let tableHeaderHeight = tableHeader ? tableHeader.clientHeight : 0;
  let tabHeight = tab ? tab.clientHeight : 0;
  let computedHeight =
    documentHeight -
    appHeaderHeight -
    appFooterHeight -
    rtHeaderHeight -
    paginationHeight -
    tableHeaderHeight -
    tabHeight -
    32;
  return Math.min(MAX_HEIGHT, Math.max(computedHeight, MIN_HEIGHR));
}

window.onresize = () => {
  store.UPDATE_TABLE_HEIGHT();
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/table/store.js